import React, {memo, useMemo} from "react";
import {useSelector} from "react-redux";
import moment from "moment";
import ChatDrawerAvatarGroup from "@iso/components/ChatDrawer/ChatDrawerAvatarGroup";
import {CloseOutlined} from "@ant-design/icons";
import {CHAT_GROUP} from "@iso/components/ChatDrawer/ChatDrawer";
import { REACT_APP_CLOUD_FRONT } from "@iso/config/config";

const getFileURL = (path) => {
  return `${REACT_APP_CLOUD_FRONT}/${path}`
}

const getAvatars = (conversation) => {
  if (!conversation?.avatar && conversation?.avatar.length <= 0) return null;

  return conversation.avatar.map(avatar => ({
    fullName: avatar?.name || '',
    avatarURL: avatar?.photos && avatar?.photos.length > 0 && avatar.photos[avatar.photos.length - 1]?.path?.origin
      ? getFileURL(avatar.photos[avatar.photos.length - 1]?.path?.origin)
      : null
  }))
}

const getCreatedAt = (conversation) => {
  if (!conversation?.created) return null;

  const dateCreated = moment(conversation.created);
  const diffWithTodayDays = moment().diff(dateCreated, 'days');

  if (diffWithTodayDays <= 5) {
    return dateCreated.calendar();
  }

  return dateCreated.format('DD MMM YYYY') ;
}

const ChatDrawerHeader = ({ onClose }) => {
  const { selected, type } = useSelector(state => state.chat);

  const conversationName = useMemo(() => {
    if (type === CHAT_GROUP.DIRECT) {
      return selected?.createBy?.fullName || ''
    }

    return selected?.match?.job?.jobName || '';
  }, [selected])

  const conversationCreatedAt = useMemo(() => {
    const createdAt = getCreatedAt(selected);

    return createdAt ? `Start: ${createdAt}` : '';
  }, [selected]);

  const conversationAvatars = useMemo(() => {
    return getAvatars(selected)
  }, [selected])

  if (!selected) {
    return <></>;
  }

  return (
    <>
      <div className='flex gap-5 items-center chat-header p-5 border-b-2 chat-header box-border'>
        <div className='w-[70px]'>
          <ChatDrawerAvatarGroup items={conversationAvatars} defaultProfile={selected?.createBy} />
        </div>
        <div className='flex flex-col w-full'>
          <span className='font-bold text-base'>{conversationName}</span>
          <span className='text-[#77757F] text-xs'>{conversationCreatedAt}</span>
        </div>
        <div className='flex justify-end'>
          <CloseOutlined onClick={() => onClose && onClose()} />
        </div>
      </div>
    </>
  );
}

export default memo(ChatDrawerHeader);
